export default "__VITE_PUBLIC_ASSET__6b4d09d6__"